module.exports = __webpack_public_path__ + "static/media/bo.69a405de.svg";